<template>
	<LayoutTabs class="view-stickers">
		<template slot="title">Sticker Overview</template>
		<template slot="tabs">
			<span
				class="tab__item"
				:class="{'tab__item--active' : index === active}"
				v-for="(tab, index) in tabs"
				:key="index"
				@click="active = index"
			>
				{{ tab }}
			</span>
		</template>

		<template slot="content" v-if="active === 0">
			<LayoutDetails class="content__table">
				<template slot="image">
					<AppImage
						:src="require('@/assets/img/default-emoji.png')"
						:fallback="require('@/assets/img/default-emoji.png')"
						:title="stickerName"
					/>
				</template>

				<template slot="title">{{ stickerName }}</template>

				<template slot="controls">
					<AppButton
						modifier="small-primary"
						@click="$router.push({ name: 'stickers-update' })"
					>
						Edit
					</AppButton>
					<AppButton modifier="small-danger">Delete</AppButton>
				</template>

				<AppInfo label="Name">{{ stickerName }}</AppInfo>

				<div>
					<AppInfo label="Date Added">--</AppInfo>
					<AppInfo label="User download">2495</AppInfo>
				</div>

				<AppInfo label="Description">Lorem ipsum dolor sit amet.</AppInfo>
				<AppInfo label="Artist">Taison Digital</AppInfo>
				<AppInfo label="Price">$4</AppInfo>
			</LayoutDetails>
		</template>

		<template slot="content" v-if="active === 1">
			<div class="content__grid sticker-wrapper">
				<div
					class="sticker"
					v-for="n in 12"
					:key="n"
				>
					<div class="sticker__image-wrapper">
						<AppImage
							class="sticker__image"
							title="sticker"
							:src="require('@/assets/img/default-emoji.png')"
							:fallback="require('@/assets/img/default-emoji.png')"
						/>
					</div>

					<p class="sticker__name">name</p>
				</div>
			</div>
		</template>

		<template slot="content" v-if="active === 2">
			<div class="sticker-wrapper">
				<div
					class="sticker"
					v-for="sticker in viewStickers.emoji"
					:key="sticker.id"
				>
					<div class="sticker__image-wrapper">
						<AppImage
							class="sticker__image"
							title="sticker"
							:src="sticker.filepath"
							:fallback="require('@/assets/img/default-emoji.png')"
						/>
					</div>

					<p class="sticker__name">{{ sticker.emotion }}</p>
				</div>
			</div>
		</template>

		<template slot="content" v-if="active === 3">
			<div class="sticker-wrapper">
				<div
					class="sticker"
					v-for="sticker in viewStickers.sticker"
					:key="sticker.id"
				>
					<div class="sticker__image-wrapper">
						<AppImage
							class="sticker__image"
							title="sticker"
							:src="sticker.filepath"
							:fallback="require('@/assets/img/default-emoji.png')"
						/>
					</div>

					<p class="sticker__name">{{ sticker.emotion }}</p>
				</div>
			</div>
		</template>
	</LayoutTabs>
</template>

<script>
import * as stickerModule from '@/store/sticker'
import { mapFields } from 'vuex-map-fields'
import LayoutTabs from '@/components/layouts/LayoutTabs'

export default {
	props: ['name'],

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['sticker/']) {
			this.$store.registerModule('sticker', stickerModule.default)
		}
	},

	created () {
		const { keyword } = this.$route.query
		this.keyword = keyword || ''
		this.getList()
	},

	data () {
		return {
			showUpdateStickerInfo: false,
			keyword: '',
			active: 0,
			tabs: ['Sticker Details', 'Mood Emoji', 'Emotion Set', 'Sticker Emoji']
		}
	},

	methods: {
		search () {
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.getList()
			}, 500)
		},

		getList () {
			const form = new FormData()
			form.append('set_name', this.stickerName)
			form.append('keyword', this.keyword)

			const query = {}
			if (this.keyword) {
				query.keyword = this.keyword
			}

			this.$router.push({ query: query })
			this.$store.dispatch('sticker/view', { form, name: this.name })
		}
	},

	computed: {
		stickerName () {
			return this.name.split('-').join(' ')
		},

		...mapFields('sticker', [
			'viewStickers',
			'viewStickersLoading'
		])
	},

	components: {
		LayoutTabs
	}
}
</script>

<style lang="scss" scoped>
.view-stickers {
	height: 100%;
	overflow: hidden;
}

.sticker-wrapper {
	width: 100%;
	max-width: 32em;
	display: flex;
	flex-flow: row wrap;

	.sticker {
		display: inline-block;
		margin: 0 1em 2.5em 1em;

		&__image-wrapper {
			height: 6em;
			width: 6em;
			padding: .5em;
			border-radius: 50%;
			background-color: #fff;
			overflow: hidden;
			box-shadow: 0 0 2px $default-light;
		}

		&__image {
			width: 100%;
			height: 100%;
		}

		&__name {
			margin-top: .5em;
			text-align: center;
			text-transform: capitalize;
		}
	}
}
</style>
